<template>
    <section id="manger"  class="MealPlan" v-if="sections.length">
      <h2 class="MP__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour manger</h2>
  
      <div class="MP__grid">
        <article v-for="(sec, idx) in sectionsSorted" :key="sec.id || idx" class="MP__card">
          <header class="MP__cardHead">
            <h3 class="MP__day merriweather-reg-20">{{ sec.title }}</h3>
            <div class="MP__rule"></div>
          </header>
  
          <div class="MP__rows">
            <div v-for="(it, i) in (sec.meal_plan_items || [])" :key="it.id || i" class="MP__row">
              <div class="MP__time raleway-semi-p15">{{ it.time_text }}</div>
              <div class="MP__content raleway-semi-p15">
                <div class="MP__rowTitle">{{ it.title }}</div>
                <div class="MP__desc raleway-reg-p15" v-if="it.description">{{ it.description }}</div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'MealPlanGrid',
    props: { sections: { type: Array, default: () => [] } },
    data() {
      return {
        isPhone: window.innerWidth < 768
      }
    },
    computed: {
      sectionsSorted(){
        return [...this.sections].sort((a,b)=>(a.position??0)-(b.position??0))
      }
    }
  }
  </script>
  
  <style scoped>
  .MealPlan{ padding: 26px 16px 8px; }
  .MP__title{
    text-align:center;
    margin: 0 0 clamp(10px, 1.8vw, 14px);
    color:#0d0d0d;
    margin: 0 0 18px;
  }
  
  .MP__grid{
    max-width:1200px; margin:0 auto;
    display:grid; gap:18px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 980px){ .MP__grid{ grid-template-columns: 1fr; } }
  
  .MP__card{
    background:#F5F5F5; /* soft green */
    border-radius:18px;
    padding: 20px 22px;
    border:1px solid #e4eee8;
  }
  
  .MP__cardHead{ display:grid; align-items:center; row-gap:10px; }
  .MP__day{
    color:#3B6152;
    margin:0;
    text-align:center;
  }
  .MP__rule{
    height:2px; width:100%;
    background:#c9d9d2;
    margin: 8px 0 12px;
  }
  
  .MP__rows{ display:grid; gap:18px; }
  .MP__row{ display:grid; grid-template-columns: 100px 1fr; column-gap:18px; align-items:start; }
  .MP__time{
    color:#3B6152;
    letter-spacing:.3px;
  }
  .MP__content{ display:grid; gap:6px; }
  .MP__rowTitle{
    color:#0d0d0d;
  }
  .MP__desc{
    color:#232323;
    opacity:.9;
  }
  </style>  